import { Location } from "@angular/common";
import { DefaultUrlSerializer, UrlTree } from "@angular/router";

const UPPERCASE_MARKET_CODE = /^(\/[A-Z]{2,})(\/.*)?$/;

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
	parse(uri: string): UrlTree {
		const checkIfInvalid = UPPERCASE_MARKET_CODE.exec(uri);
		let newUri = uri;
		if (checkIfInvalid && checkIfInvalid[1]) {
			newUri = uri.replace(checkIfInvalid[1], checkIfInvalid[1].toLowerCase());
		} else if (uri === "/") {
			return super.parse(uri);
		}
		const emptyReferences = newUri === "" || newUri === "+" || newUri === "/+";

		if (emptyReferences) {
			return super.parse("/");
		}

		const paramStartPos = newUri.indexOf("?");
		const fragmentStartPos = newUri.indexOf("#");
		let needle = "?";

		if (paramStartPos === -1 && fragmentStartPos > -1) {
			needle = "#";
		}

		const [pathname, queryparams] = newUri.split(needle);
		newUri = `${pathname.toLowerCase()}${queryparams ? needle + queryparams : ""}`;
		return super.parse(newUri);
	}

	serialize(urlTree: UrlTree): string {
		return Location.stripTrailingSlash(urlTree.toString());
	}
}
